import $ from "jquery";

const setupAnalyticsNestedTable = () => {
  const $container = $(".site-area-table-container:not('.analytics-bound')").addClass("analytics-bound");

  $container.on("click", ".child-row-toggle", (function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $anchor = $(this);
    const $targetRow = $anchor.closest("tr");
    const id = $targetRow.attr("id");
    const expanded = $anchor.hasClass("expanded");

    const childClassSelector = `.${id}`;
    const $children = $container.find(childClassSelector);
    const $immediateChildren = $targetRow.siblings(childClassSelector);

    if (expanded) {
      $anchor.removeClass("expanded").addClass("collapsed");
      $children.find(".child-row-toggle").removeClass("expanded").addClass("collapsed");
      $children.addClass("hidden");
    } else {
      $anchor.removeClass("collapsed").addClass("expanded");
      $immediateChildren.removeClass("hidden");
    }
  }));

  $container.on("click", ".hacky-script-tag-export", function (e) {
    e.preventDefault();
    e.stopPropagation();

    window.hackyScriptTagExport(this);
  });
};

window.datatableAjaxHook = (tableHtmlId, json) => {
  const $chartContainer = $(`.${tableHtmlId}`);
  if (!$chartContainer.length) {
    return;
  }

  // TODO(SI): DO NOT do this if the table was merely sorted!
  if (json.chartRedraw) {
    // TODO(SI): Placeholder code
    //  1. Handle Highcharts not just Chartkick
    //  2. Only clear charts associated with this particular table, we might have multiple tables on one page.
    const chartkickCharts = window.Chartkick.charts;
    for (let v of Object.entries(chartkickCharts)) {
      if (v.chart) {
        // eslint-disable-next-line
        console.log("PLACEHOLDER removal");
        v.chart.clearChart();
      }
    }

    $chartContainer.html($.parseHTML(json.chartRedraw, document, true));

    setupAnalyticsNestedTable();
  }
};

$(document).on("ready turbolinks:load", function () {
  setupAnalyticsNestedTable();
});
